import classNames from 'classnames';
import { type GroupBase, type SelectComponentsConfig, components } from 'react-select';

import type { Country } from '../../../features/geography/types';
import { CountryCodeDisplay } from '../CountryCodeDisplay/CountryCodeDisplay';

import styles from './SingleValue.module.scss';

export const SingleValue: SelectComponentsConfig<
  Country,
  false,
  GroupBase<Country>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
>['SingleValue'] = ({ children, className, ...props }) => (
  <components.SingleValue className={classNames(className, styles.singleValue)} {...props}>
    <CountryCodeDisplay country={props.data} type="singleValue" />
  </components.SingleValue>
);
